import * as React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import withApp from '../components/withApp/withApp'
import SEO from '../components/Seo'
import PlanSection from '../components/PlanSection'
import FeaturedIn from '../components/FeaturedIn'
import TextLink from '../components/TextLink'
import BubbleHero, { BubbleContentWrapper } from '../components/BubbleHero'
import FreeMonthsHowTo from '../components/FreeMonthsHowTo'
import SmallBanner from '../components/FriendReferralBanner/SmallBanner'

// Global Styled Components
import SiteContainer from '../components/styles/SiteContainer'
import FullWidthContainer from '../components/styles/FullWidthContainer'
import Spacer from '../components/styles/Spacer'
import FaqSection, { referAFriendFAQList } from '../modular-system/FaqSection'

import { theme, progressiveBreakpoints } from '../constants/theme'

import FreeMonthImage from '../static/images/fancyFreeMonth.svg'
import MarketingBanner from '../components/FriendReferralBanner/MarketingBanner'
import { FEATURES } from '../config'
import { RICH_DATA_STRINGS } from '../constants/globalStrings'

const BubbleContentImage = styled.img`
  width: 100%;
  max-width: 512px;
  margin: auto;
`

const ExistingCustomersText = styled.p`
  a {
    font-size: 18px;
    line-height: 25px;
  }
`

const ExistingCustomersContainer = styled.div`
  margin-top: 48px;
`

// importants are used as i only want to change the h1 size here at mobile
const Title = styled.h1`
  font-size: 2.1rem !important;

  @media ${progressiveBreakpoints.desktopSmall} {
    font-size: 3.3rem !important;
  }
`

const ReferAFriend = ({ plans: { plans }, doFindFriend }) => (
  <React.Fragment>
    <SEO
      title={rafContent.seo.title}
      description={rafContent.seo.description}
      itemType={RICH_DATA_STRINGS.FAQ_ITEM_TYPE}
    />
    <SmallBanner doFindFriend={doFindFriend} />
    <BubbleHero>
      <BubbleContentWrapper isRaf>
        <BubbleContentImage
          src={FreeMonthImage}
          alt="Who wouldn’t fancy a free month?"
        />
        <Title>
          Give a free month,
          <br /> get a free month.
        </Title>
        <p>
          SMARTY is a new SIM-only mobile network that’s built to be simple and
          honest. Join us, refer-a-friend and you’ll both get a free month.
          Refer 12 friends and get a whole year free.{' '}
        </p>
        {FEATURES.RAF_OFFER && <MarketingBanner />}
        <FreeMonthsHowTo />
        <ExistingCustomersContainer>
          <h2>Existing customer?</h2>
          <ExistingCustomersText>
            <TextLink href="https://smarty.co.uk/dashboard/referrals">
              Login to SMARTY and start getting free mobile
            </TextLink>
          </ExistingCustomersText>
        </ExistingCustomersContainer>
      </BubbleContentWrapper>
      <Spacer />
    </BubbleHero>

    <SiteContainer
      data-module-id={plans.length > 0 ? 'plan-modules-refer-a-friend' : null}
      data-module_name="simple-plans"
      data-module_placement="products-section"
    >
      <PlanSection plans={plans} />
    </SiteContainer>
    <SiteContainer>
      <FeaturedIn />
    </SiteContainer>
    <FullWidthContainer
      background={theme.colors.background.backgroundColorDarker}
    >
      <SiteContainer>
        <FaqSection faqAccordions={referAFriendFAQList} isReferAFriend />
      </SiteContainer>
    </FullWidthContainer>
  </React.Fragment>
)

ReferAFriend.propTypes = {
  plans: PropTypes.object,
  doFindFriend: PropTypes.bool,
}

const rafContent = {
  seo: {
    title: 'Refer-a-friend',
    descripton:
      'SMARTY is a new SIM-only mobile network that’s built to be fair, transparent and smart.',
  },
}

export default withApp(ReferAFriend)
